// extracted by mini-css-extract-plugin
export default {"label":"RestrictionsAllowances_label__8JQA2","placeHolderShimmer":"RestrictionsAllowances_placeHolderShimmer__N1Nd2"};